import { render, staticRenderFns } from "./BookingFloatingBar.vue?vue&type=template&id=3284eb88&scoped=true"
import script from "./BookingFloatingBar.vue?vue&type=script&lang=js"
export * from "./BookingFloatingBar.vue?vue&type=script&lang=js"
import style0 from "./BookingFloatingBar.vue?vue&type=style&index=0&id=3284eb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284eb88",
  null
  
)

export default component.exports